module.exports = __webpack_public_path__ + "images/bg.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg.jpg
// module id = 297
// module chunks = 0